import { useWindowDimensions } from "hooks/useWindowDimensions";
import { WINDOW_SIZE } from "constants/enum";

export const useIsMobile = () => {
    const { width } = useWindowDimensions();

    return width < WINDOW_SIZE.DESKTOP;
};
